
import TasksView_LocalSettings from "../../../../core/settings/local/local-settings"

export default class List_LocalSettings extends TasksView_LocalSettings {

    protected _collapsedByGrouping      : Record<ID,ID[]>   // collapsed items IDs by grouping field id (is used when default state is expanded, e.g. List)

    constructor(localStorageKey:string) {
        super(localStorageKey);

        const values                    = this._readFromLocalStorage()
        this._collapsedByGrouping       = _.get(values, 'collapsedByGrouping', {})
    }

    get collapsedByGrouping() {
        return this._collapsedByGrouping
    }

    set collapsedByGrouping(value:any) {
        this._collapsedByGrouping = value
        this.save()
    }

    toObject() {
        const res = super.toObject()

        res.collapsedByGrouping = this.collapsedByGrouping

        return res
    }
}
